const locale: Locale = {
  ko: {
    petition: '청원하기',
  },
  en: {
    petition: 'Create a New Petition',
  },
}

export default locale
